import * as XLSX from 'xlsx';
import type { BulkCreateRowResult } from './types';

export function exportErrorsToExcel(results: BulkCreateRowResult[], fileName: string) {
  const errorRows = results.filter((r) => !r.success);

  if (errorRows.length === 0) return;

  const data = errorRows.map((r) => ({
    'מספר שורה': r.rowNumber,
    'ת.ז.': r.israeliId,
    שגיאה: r.errorMessage ?? 'שגיאה לא ידועה',
  }));

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'שגיאות');

  ws['!cols'] = [{ wch: 12 }, { wch: 15 }, { wch: 50 }];

  XLSX.writeFile(wb, fileName);
}
